import { createContext } from 'react'

import { ContextType } from 'admin/types'

const Context = createContext<ContextType>({})

export default Context
